import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { RevealerManager } from "../independent/revealer/RevealerManager";
import { SanParsedGameData } from "../../server/data/SanParsedGameData";
import { ReavealerState, Revealer } from "../independent/revealer/Revealer";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { JumpingWildController } from "../independent/jumpingWild/JumpingWildController";
import { SanEngineManager } from "../../engine/SanEngineManager";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { SanEngineController } from "../../engine/SanEngineController";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { ScatterRevealPresentation } from "../features/scatter/ScatterRevealPresentation";
import { SanSpriteSymbol } from "../../engine/Symbol/SanSpriteSymbol";
import { PostCounter } from "../independent/poster/PostCounter";
import { ReelOverlay } from "../background/ReelOverlay";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { SanGameConfig } from "../../SanGameConfig";
import { SplashController } from "../independent/splashScreen/SplashController";
import { JumpingWildCollector } from "../independent/collector/JumpingWildCollector";
import { XWaysCounter } from "../independent/countup/XWaysCounter";
import { SoundManager } from "../../resource/sound/SoundManager";
import { SoundConfig } from "../../SoundConfig";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import { SanBackground } from "../background/SanBackground";
import {IReelSpriteSymbol} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/IReelSpriteSymbol";

class StoppedState extends StateHandler{
    public static readonly NORMAL:string = "normal";
    public static readonly FS:string =  "fs";
    public static readonly FS_START_JUMP:string =  "fs_start_jump";
    public static readonly FS_JW_WON_DELAY:string =  "fs_jw_won_delay";

    public static readonly FS_JW_WON:string =  "fs_jw_won";

    public static readonly FS_NEW_SCATTER_DELAY:string =  "fs_new_scatter_delay";

    public static readonly FS_NEW_SCATTER:string =  "fs_new_scatter";

    public static readonly FIRST_FS:string =  "first_fs";

    public static readonly FS_BAR:string =  "fs_bar";

    public static readonly SKIPPED_FS_COUNT:string =  "skipper_fs_count";
    public static readonly FS_AMOUNT_RESULT:string =  "fs_amount_result";
    public static readonly FS_AMOUNT_RESULT_END:string =  "fs_amount_result_end";
}

export class ReelStoppedPresentation extends Presentation {

    private _gameData:SanParsedGameData;
    private stopState:StoppedState = new StoppedState(StoppedState.NORMAL);

    private isFS:boolean = false;
    private isStartFS:boolean = false;

    private skipAble:boolean = false;

    public setParsedGamedData(data: SanParsedGameData): void {
        this._gameData = data;
        this.isFS = data.mode === GameMode.FREESPIN;
        this.isStartFS = data.mode === "FREESPIN_SETUP";

        if(this.isStartFS){
            this.stopState.set(StoppedState.FS_JW_WON_DELAY);
        }
        else{
            this.stopState.set(this.isFS ? StoppedState.FS : StoppedState.NORMAL);
            this.stopState.set(this.isFS && data.scatterAmount > 0 ? StoppedState.FS_NEW_SCATTER_DELAY : this.stopState.state);
        }
    }

    public checkForActivation(data:any):boolean{
        return data.scatterAmount > 0 || data.mode === GameMode.FREESPIN || data.mode === "FREESPIN_SETUP";
    }

    public getPresentation(): void {
        
        switch(this.stopState.state){
            case StoppedState.FS_JW_WON_DELAY:
                this.pTimeline.to(this,0.15,{});
                this.stopState.set(StoppedState.FS_JW_WON);
                break;
            case StoppedState.FS_JW_WON:
                this.ShowFsWon();
                break;
            case StoppedState.FS_START_JUMP:
                this.switchToFreespinScreen();
                break;
            case StoppedState.FIRST_FS:
                this.freeSpinBars();
                break;
            case StoppedState.FS:
                this.fsStopped();
                break;
            case StoppedState.FS_NEW_SCATTER_DELAY:
                this.pTimeline.to(this,0.5,{});
                this.stopState.set(StoppedState.FS_NEW_SCATTER);
                break;
            case StoppedState.FS_NEW_SCATTER:
                this.fsScatter();
                break;
            case StoppedState.FS_BAR:
                this.fsScatterBar();
                break;
            case StoppedState.SKIPPED_FS_COUNT:
                this.skippedFSCount();
                break;
            case StoppedState.FS_AMOUNT_RESULT:
                this.ShowResult();
                break;
            case StoppedState.FS_AMOUNT_RESULT_END:
                this.endResult();
                break;
            default:
                this.normalStopped();
                break;
        }
    }

    private ShowFsWon():void{
        this.skipAble = false;

        const symKey:string = Object.keys(this._gameData.rawData.specialSymbol)[0];
        // SplashViewJWWon.changeValue(this._gameData.fsSym.val);

        SanEngineManager.RAll((r:number) => {
            if(SanEngineManager.getReel(r).isActive){
                const rc:SanEngineController = SanEngineManager.getReel(r);

                rc.AllWindowSymbols.forEach(s => {
                    if(s.symName === "Z"){
                        this.pTimeline.add((<SanSpriteSymbol>s).mysteryExplosion(),0);
                        s.changeState({
                            state: ReelSymbolStates.CHANGE_SYMBOL,
                            forceState: true,
                            newSym: symKey,
                            type: "4",
                            duration: 0.5,
                        });
                    }
                })
            }
        });

        SoundManager.playSoundEffect(SoundConfig.instance.FS_MYSTERY_REVEAL);
        
        this.pTimeline.add(() => SplashController.instance.stop());

        const timePos:number = this.pTimeline.totalDuration() + 0.6;

        let delayBetween:number = 0;
        SanEngineManager.RAll((r:number) => {
            if(SanEngineManager.getReel(r).isActive){
                const rc:SanEngineController = SanEngineManager.getReel(r);
                if(this._gameData.fsSym.sym && this._gameData.fsSym.sym != "W"){
                    rc.AllWindowSymbols.forEach(s => {
                        if(s.symName !== "X" && s.symName !== "W" && s.symName !== "Z"){
                            this.pTimeline.add(() => { 
                                (<SanSpriteSymbol>s).showAppliedValue(this._gameData.fsSym.val);
                                SoundManager.playSoundEffect(SoundConfig.instance.FS_MULTIPLIER_COLLECT);
                            },timePos + delayBetween);
                            delayBetween += 0.1;
                        }
                    }
                )}
            }
        });
        
        PostCounter.instance.setPostType(this._gameData.fsSym.sym,this._gameData.fsSym.val);
        SanEngineManager.setFSSymbol(this._gameData.fsSym.sym,this._gameData.fsSym.val);
        RevealerManager.setFSSymbol(this._gameData.fsSym.sym,this._gameData.fsSym.val);

        if(symKey === "W"){
            SoundManager.playSoundEffect(SoundConfig.instance.FS_POLICE_IN)
            this.pTimeline.add([
                () => PostCounter.instance.showWildWon()
            ]);
            this.pTimeline.to(this,PostCounter.instance.getWildDurr(),{});
            this.pTimeline.add([
                () => JumpingWildCollector.instance.upgradeJW(this._gameData.fsSym.val),
                () => SoundManager.playSoundEffect(SoundConfig.instance.WILD_UPGRADE),
            ], PostCounter.instance.getWildDurr()/2);
            
            this.pTimeline.to(this,0.5,{}, PostCounter.instance.getWildDurr()/2);
        }else{
            this.pTimeline.to(this,0.6,{});
        }

        this.stopState.set(StoppedState.FS_START_JUMP);
    }

    private switchToFreespinScreen():void{

        if(this._gameData.rawData.topRowOpened.indexOf(false) >= 0)
            SoundManager.playSoundEffect(SoundConfig.instance.FS_JAIL_DOOR_OPEN)

        for(let i:number = 0; i < SanEngineManager.AllReels.length; i++){
            this.pTimeline.add(SanEngineManager.getReel(i).reelLocker(false), 0);
        }

        ReelOverlay.instance.changeAlpha(0.65, 0.5);
        RevealerManager.getAllBars().forEach(b => {
            b.attentionDarkness(b.isActive ? 0 : 0.35 ,0.2);
            b.showRevSpinner(true);
        })

        let ammWildsFetched:number = JumpingWildController.instance.items.length;

        for(let r:number = 0; r < SanEngineManager.AllReels.length;r++){

            if(!this._gameData.rawData.topRowOpened[r] || this._gameData.wildReelPositions[r].length == 0) continue;

            if(ammWildsFetched != 0){
                --ammWildsFetched;
                continue;
            }
            JumpingWildController.instance.createJumpWild(r,this._gameData.wildReelPositions[r][0],0);
        }
        
        this.stopState.set(StoppedState.FIRST_FS);
    }

    private fsScatter():void{
        this.convertScatters();
        for(let r:number = 0; r < SanEngineManager.AllReels.length; r++){
            if(this._gameData!.scatterReelPositions[r] >= 0){
                SanEngineManager.getReel(r).AllWindowSymbols.forEach((value: IReelSpriteSymbol, index: number, array: IReelSpriteSymbol[]) =>{
                    (<SanSpriteSymbol>value).dirrAtt(false);

                });
            }
        }

        this.pTimeline.to(this,0.1,{});
        this.stopState.set(StoppedState.FS_BAR);
    }

    private fsScatterBar():void{

        let countAmmFS:number = 0;

        let ignoreSound:boolean = this._gameData!.scatterAmount == 2;

        for(let r:number = 0; r < SanEngineManager.AllReels.length; r++){
            if(this._gameData!.scatterReelPositions[r] >= 0){
                if(ignoreSound){
                    RevealerManager.getTopBar(r).setBounceSound(false);
                    RevealerManager.getBotBar(r).setBounceSound(false);
                    ignoreSound = false;
                }
                this.pTimeline.add(ScatterRevealPresentation.revealBar(r),0);
                countAmmFS += parseFloat(this._gameData.rawData.cellReelOne[r]);
                countAmmFS += parseFloat(this._gameData.rawData.cellReelTwo[r]);
            }
        }

        this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_PLUS_SPINS),SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.STOP/4);

        this.pTimeline.add(PostCounter.instance.play(countAmmFS,this._gameData.freespinsLeft - countAmmFS),"+=" +0.2);

        this.pTimeline.add(() => SanBackground.instance.playAtmosphere(JumpingWildController.instance.items.length-1));
        // this.pTimeline.add(() => SanBackground.instance.fsSpineBG(JumpingWildController.instance.items.length-1));
        this.pTimeline.to(this,0.2,{});
        this.pTimeline.add(() => {
            RevealerManager.getAllBars().forEach(b => { 
                if(b.isActive) b.setBounceSound(true);
            })
        });

        this.stopState.set(StoppedState.FS);
    }

    private fsStopped():void{
        this.skipAble = false;
        if(this.stopState.lastState != StoppedState.FS_BAR) this.convertScatters();

        const allBars:Revealer[] = RevealerManager.getAllBars();
        let expandDelay:number = 0;

        for(let r:number = 0; r < allBars.length; r++){
            if(allBars[r].state.equal(ReavealerState.EXPANDING) && allBars[r].isActive){
                this.pTimeline.add(allBars[r].expandRes(true,0),0);
                expandDelay = 0.3;
            }
        }

        if(this._gameData.singleWin == 0){
            for (let reel = 0; reel < SanEngineManager.AllReels.length; reel++) {
                SanEngineManager.getReel(reel).AllWindowSymbols.forEach(s => (<SanSpriteSymbol>s).attentionDarkness(0,0.2));
                RevealerManager.getTopBar(reel).attentionDarkness(0,0.2);
                RevealerManager.getBotBar(reel).attentionDarkness(0,0.2);
            }
        }
        
        this.pTimeline.to(this, this._gameData.isBigWin && SanEngineManager.isQuickStop || GameSetting.isFastSpin ? 0.1 : 0.2,{},0);

        XWaysCounter.instance.setValue(undefined,this._gameData.rawData.totalWays,0.15);
        
        this.pTimeline.to(this, expandDelay ,{},0);
        this.PresentationState.set(this._gameData.nextMode === GameMode.NORMAL ? PresentationState.INACTIVE : PresentationState.END);
    }

    private skippedFSCount():void{
        let restTime:number = 0;
        RevealerManager.getAllBars().forEach(r =>{
            r.setBounceSound(false);
            restTime = Math.max(r.restShuffleTime,restTime)
        })
        this.pTimeline.to(this,restTime+0.65,{});
        this.stopState.set(StoppedState.FS_AMOUNT_RESULT);
    }

    private ShowResult():void{
        this.skipAble = false;
        this.pTimeline.add(PostCounter.instance.playResultFS())
        this.pTimeline.to(this,0.5,{});
        this.stopState.set(StoppedState.FS_AMOUNT_RESULT_END);
    }
    private endResult():void{

        SanEngineManager.isFirstFS = false;
        for(let i:number = 0; i < SanEngineManager.AllReels.length; i++){
            SanEngineManager.getReel(i).isActive = true;
            this.pTimeline.add(SanEngineManager.getReel(i).changeAlpha(0.35,0.2), 0);
        }

        ReelOverlay.instance.changeAlpha(0, 0.5);
        RevealerManager.getAllBars().forEach(b => { 
            b.attentionDarkness(0);
            if(b.isActive) b.setBounceSound(true);
        })
        

        this.pTimeline.add(PostCounter.instance.playEnd());
        this.pTimeline.to(this,0.35,{});
        this.PresentationState.set(PresentationState.END);
    }

    skipPresentation():void{
        if(this.skipAble){
            this.skipAble = false;
            PostCounter.instance.QuickClicked = true;
            this.PresentationState.set(PresentationState.ACTIVATED);
            this.stopState.set(StoppedState.SKIPPED_FS_COUNT);
            this.pTimeline.totalProgress(1);
        }
    }

    private freeSpinBars(): void {

        PostCounter.instance.setAmount(0);
        
        let delay: number = PostCounter.instance.playShow().duration()/2;
        
        for (let tb: number = 0; tb < 2; tb++) {
            const isTopBar:boolean = tb == 0;
            const revVal:string[] = isTopBar ? this._gameData!.rawData.cellReelOne : this._gameData!.rawData.cellReelTwo;
            for (let r: number = 0; r < SanEngineManager.AllReels.length; r++) {
                if (RevealerManager.getBotBar(r).isActive) {
                    delay = this.genSpinePath(isTopBar, r, parseInt(revVal[r]), delay )
                }
            }
        }
        this.skipAble = true;
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        this.pTimeline.to(this, 1 , {});
        this.stopState.set(StoppedState.FS_AMOUNT_RESULT);
    }

    private genSpinePath(isTop:boolean,reelID:number,indx:number,startOffset:number):number{
        let totDurr:number = startOffset;
        const rev:Revealer = isTop ? RevealerManager.getTopBar(reelID) : RevealerManager.getBotBar(reelID);
        this.pTimeline.add(() => rev.shuffle(false).add(() => PostCounter.instance.Stroker(indx)),totDurr);
        totDurr +=  SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.STOP*(GameSetting.isFastSpin ? 0.5 : 1);
        return totDurr;
    }

    private normalStopped():void{
        if(this._gameData.nextMode !== "FREESPIN_SETUP") this.convertScatters();

        this.PresentationState.set(PresentationState.INACTIVE);
    }

    private convertScatters():void{
        if(this._gameData.scatterAmount == 0) return;

        let delay:number = 0;

        for(let r:number = 0; r < SanEngineManager.AllReels.length;r++){
            const scattPos:number = this._gameData!.scatterReelPositions[r];
            if(scattPos == -1) continue;
            const SEN:SanEngineController = SanEngineManager.getReel(r);

            delay = this.pTimeline.add([
                SEN.getSymbol(scattPos)!.changeState({
                    state: ReelSymbolStates.CHANGE_SYMBOL,
                    newSym: this.isFS ?  "W_J" : "W",
                    animated: this.isFS
                }),
                SEN.getSymbol(scattPos)!.attentionFlash(0.5),
            ],0).duration();

            RevealerManager.getTopBar(r).attentionDarkness(0,0.2);
            RevealerManager.getBotBar(r).attentionDarkness(0,0.2);

            if(this.isFS){
                this.pTimeline.add(() => JumpingWildController.instance.createJumpWild(r,scattPos,0));
            }
        }
        if(this.isFS){
            SoundManager.playSoundEffect(SoundConfig.instance.SCATTER_TO_WILD_FS);
        }else
            SoundManager.playSoundEffect(SoundConfig.instance.SCATTER_TO_WILD);
    }

    public endPresentation():void{
        const bars:Revealer[] = RevealerManager.getAllBars();
        this.skipAble = false;
        let expandDelay:number = 0;

        RevealerManager.getAllBars().forEach(b => b.attentionDarkness(0, 0.2));

        for(let i =0; i < bars.length;i++){
            if(bars[i].isActive){
                expandDelay = this.pTimeline.add(bars[i].expandRes(false),0).duration();
            }
        }

        this.pTimeline.to(this,0.2,{});

        if(!JumpingWildCollector.instance.showing)
            for(let j = 0; j < JumpingWildController.instance.items.length; j++){
                this.pTimeline.add(() => JumpingWildController.instance.MergeWithReel(j,false) );
            }

        this.PresentationState.set(PresentationState.INACTIVE);
    }
}

